import { useEffect } from 'react';

/**
 * Block pointer events from reaching the paneling drawer underneath.
 * Vaul portals to <body>, so React stopPropagation won't help — the
 * paneling drawer's pointer-event-based gesture system lives in a
 * separate DOM subtree. We use a document-level capturing listener
 * to intercept pointer events that target anything outside the vaul
 * drawer and its overlay.
 */
export const useBlockUnderlyingPointerEvents = (open: boolean) => {
	useEffect(() => {
		if (!open) return;

		const blocker = (e: PointerEvent) => {
			const target = e.target;
			if (!(target instanceof Element)) return;
			if (target.closest('[data-vaul-drawer]') || target.closest('[data-vaul-overlay]')) {
				return;
			}
			e.stopPropagation();
			e.preventDefault();
		};

		document.addEventListener('pointerdown', blocker, true);
		document.addEventListener('pointermove', blocker, true);
		document.addEventListener('pointerup', blocker, true);

		return () => {
			document.removeEventListener('pointerdown', blocker, true);
			document.removeEventListener('pointermove', blocker, true);
			document.removeEventListener('pointerup', blocker, true);
		};
	}, [open]);
};
